import { createFileRoute } from '@tanstack/react-router'
import { guardStudentOnly } from '@/lib/auth/routeGuards'
import StudentExamSchedule from '@/components/studentPage/StudentExamSchedule'

export const Route = createFileRoute('/student/exam-schedule')({
  beforeLoad: guardStudentOnly,
  component: StudentExamSchedule,
})
